import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

function LocationList({ locations, onClickAddress }) {
    const [t] = useTranslation('ourDistributors');

    return (
        <>
            {locations.map((location, index) => (
                <div
                    key={location.address}
                    className={index > 0 ? 'mt-12 sm:mt-20' : ''}
                >
                    <p className={'mb-6 text-2xl font-bold text-white'}>{`${t('location')} ${index + 1}`}</p>
                    <p
                        className={'text-xl text-white hover:cursor-pointer hover:text-opacity-50'}
                        onClick={() => onClickAddress(location.address)}
                    >
                        {location.address}
                    </p>
                    <p className={'mt-2 text-xl text-white'}>{location.contact}</p>
                </div>
            ))}
        </>
    );
}

LocationList.propTypes = {
    locations: PropTypes.array,
    onClickAddress: PropTypes.func,
};

LocationList.defaultProps = {
    locations: [],
    onClickAddress: () => {},
};

export default LocationList;
